import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import "./users.less";

import MantaLegacyPageRedirect from "./manta_legacy_page_redirect";
import Spinner from "@ui/spinner";
import DemystLogoShort from "../../assets/svgs/demystLogoShort";

import { isLocation } from "../../utility/prop-types";

// Asynchronously loaded routes
const NotActivatedYet = lazy(() =>
  import(/* webpackChunkName: "not_activated_yet" */ "../not_activated_yet"));
const SignUp = lazy(() =>
  import(/* webpackChunkName: "sign_up" */ "../../containers/sign_up"));
const SignIn = lazy(() =>
  import(/* webpackChunkName: "sign_in" */ "../../containers/sign_in"));
const ResetPassword = lazy(() =>
  import(
    /* webpackChunkName: "reset_password" */ "../../containers/reset_password"
  ));
const SendResetPasswordInstructions = lazy(() =>
  import(
    /* webpackChunkName: "send_reset_password_instructions" */ "../../containers/send_reset_password_instructions"
  ));
const ResendUnlockInstructions = lazy(() =>
  import(
    /* webpackChunkName: "resend_unlock_instructions" */ "../../containers/resend_unlock_instructions"
  ));
const ResendConfirmationInstructions = lazy(() =>
  import(
    /* webpackChunkName: "resend_unlock_instructions" */ "../../containers/resend_confirmation_instructions"
  ));

const resendUnlockInstructionsProps = {
  errorMessage: "An error occurred while sending user unlocking instructions.",
  headerLabel: "Resend unlock instructions",
  submitLabel: "Resend Unlock Instructions",
  instructionsSentMessage:
    "Instructions for unlocking your account has been resent to"
};

const sendResetPasswordInstructionsProps = {
  errorMessage: "An error occurred while sending reset password instructions.",
  headerLabel: "Forgot your password?",
  submitLabel: "Send reset instructions",
  instructionsSentMessage:
    "Instructions for resetting your password have been sent to"
};

const resendConfirmationInstructions = {
  errorMessage: "An error occurred while sending user confirming instructions.",
  headerLabel: "Resend confirmation instructions",
  submitLabel: "Resend Confirmation Instructions",
  instructionsSentMessage:
    "Instructions for confirming your account has been resent to"
};

function Users({ currentUser, location }) {
  const isLoggedIn = Boolean(currentUser);

  const defaultLocation = (location.state && location.state.locationAfterLogin) || "/";

  return (
    <div className="Users">
      <div className="Users__container">
        <div className="Users__logo">
          <a href="https://platform.demyst.com/">
            <DemystLogoShort />
          </a>
        </div>
        <div className="Users__card">
          <Suspense fallback={<Spinner big multicolor />}>
            <Switch>
              <Route
                path="/users/password_expired"
                component={MantaLegacyPageRedirect}
              />
              {!isLoggedIn && (
                <Route path="/users/sign_in" component={SignIn} />
              )}
              {!isLoggedIn && (
                <Route path="/users/sign_up" component={SignUp} />
              )}
              {!isLoggedIn && (
                <Route path="/users/password/edit" component={ResetPassword} />
              )}
              {!isLoggedIn && (
                <Route
                  path="/users/password/new"
                  render={() => (
                    <SendResetPasswordInstructions
                      {...sendResetPasswordInstructionsProps}
                    />
                  )}
                />
              )}
              {!isLoggedIn && (
                <Route
                  path="/users/unlock"
                  render={() => (
                    <ResendUnlockInstructions
                      {...resendUnlockInstructionsProps}
                    />
                  )}
                />
              )}
              {!isLoggedIn && (
                <Route
                  path="/users/confirmation"
                  render={() => (
                    <ResendConfirmationInstructions
                      {...resendConfirmationInstructions}
                    />
                  )}
                />
              )}
              }
              <Route
                path="/users/not_activated_yet"
                component={NotActivatedYet}
              />
              <Redirect to={defaultLocation} />
            </Switch>
          </Suspense>
        </div>
        <div className="Users__footer">
          <nav>
            <ul>
              <li>
                <a href="mailto:support@demystdata.com">Support</a>
              </li>
              <li>
                <a href="/terms">Terms</a>
              </li>
              <li>
                <a href="/privacy">Privacy</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

Users.propTypes = {
  currentUser: PropTypes.object,
  location: isLocation.isRequired
};

export default connect(store => ({
  currentUser: store.session.data && store.session.data.user
}))(Users);
